import { render, staticRenderFns } from "./module-setting.vue?vue&type=template&id=0593e626&scoped=true&"
import script from "./module-setting.vue?vue&type=script&lang=js&"
export * from "./module-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0593e626",
  null
  
)

export default component.exports